import { render } from "./Log.vue?vue&type=template&id=28d1f8d0&scoped=true"
import script from "./Log.vue?vue&type=script&lang=js"
export * from "./Log.vue?vue&type=script&lang=js"

import "./Log.vue?vue&type=style&index=0&id=28d1f8d0&scoped=true&lang=css"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d1f8d0"]])

export default __exports__